enum BarcodeType {
  CODE_39 = 'CODE39',
  CODE_128 = 'CODE128',
  QR = 'QR',
  UPC = 'UPC',
}
export default BarcodeType;
